export default "https://cdn-static.gokick.com/assets/4e1d6b599b0c658e33aa5c1b8604da35a9a49f05/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";